module.exports = __webpack_public_path__ + "img/1200px-Vue.js_Logo_2.svg-min.c8baf97b.png";